import { t } from "@lingui/macro";
import _ from "lodash";

import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";

import {
  EventMemberControl,
  EventPrimaryChargeType,
} from "./__generated__/EventDetailPricingSection_event.graphql";

type EventDetailPricingCardProps = {
  displayName: string;
  displayDescription?: string;
  price: number | null;
  memberControl: EventMemberControl;
  primaryChargeType: EventPrimaryChargeType;
};

export const EventDetailPricingCard = ({
  displayName,
  displayDescription,
  price,
  memberControl,
  primaryChargeType,
}: EventDetailPricingCardProps) => {
  const { currencySymbol } = useGetClubCurrency();
  const isSelectable = memberControl === "SELECTABLE";
  const backgroundColor = isSelectable ? "surface-primary" : "grayscale-200";

  const displayPrice = _.isNumber(price) ? (price / 100).toFixed(2) : null;

  return (
    <Box
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      py={5}
      px={6}
      maxWidth={1240}
      borderRadius="6"
      backgroundColor={backgroundColor}
      borderWidth={isSelectable ? 1 : 0}
      borderColor="grayscale-200"
    >
      <Box maxWidth={"50%"}>
        <Text variant="mainBaseMedium">{displayName}</Text>
      </Box>
      <VStack>
        <Text
          variant="mainHeading"
          color="text-primary"
          textAlign="right"
        >{`${currencySymbol}${displayPrice}/${
          primaryChargeType === "PER_SIGN_UP" ? t`Group` : t`Person`
        }`}</Text>
        <Text variant="mainTiny" color="text-secondary" textAlign="right">
          {displayDescription}
        </Text>
      </VStack>
    </Box>
  );
};
